module.exports = __webpack_public_path__ + "static/logo_simplicity-f7c493f8c0261aefc558bfd8600c8c0b.svg";